import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, tenant, loading } = useAuth();
  if (loading) {
    return <div>Loading...</div>; // Or a spinner component
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user && !tenant){
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default ProtectedRoute;
